import { getFormattingLocale } from '../../utils';
import { DateFormat, getReactIntlDateFormatOptions } from './utils';

/**
 * Returns input-friendly placeholder formats for date pickers and form inputs.
 * Unlike display formats, input placeholders use consistent padding and 4-digit years
 * for better UX and predictable data entry while respecting locale ordering.
 */
export const usePlaceholderFormat = () => {
  const locale = getFormattingLocale();

  return (format: DateFormat = 'input_date'): string => {
    switch (format) {
      case 'input_date':
      default: {
        const formatOptions = getReactIntlDateFormatOptions(format);

        // Get the locale ordering but use input-friendly formatting
        const testDate = new Date(2025, 0, 15); // Jan 15, 2025
        const parts = new Intl.DateTimeFormat(
          locale,
          formatOptions,
        ).formatToParts(testDate);

        const result = parts
          .map((part) => {
            switch (part.type) {
              case 'year':
                return 'yyyy';
              case 'month':
                return 'mm';
              case 'day':
                return 'dd';
              case 'literal':
                return part.value;
              default:
                return '';
            }
          })
          .join('')
          .toLowerCase();

        return result;
      }
    }
  };
};
